import React from "react";
import Footer from "../components/footer";
import SubpageTitle from "../components/subpageTitle";

function ReturnProcess() {
    return (
        <div>
            <SubpageTitle title="Return Process" subtitle="Returning your empty bottles and cans is easier than ever with Bottle Depot! In a simple three-step process, you can easily get your money back."/>
            <div className='py-10 px-5'>
                <p className="text-2xl font-semibold">Step One: Collect Your Bottles</p>
                <p className="py-3">There are no limits to the number of empties you can return and the containers do not need to be sorted.</p>
                <p className="text-2xl font-semibold">Step Two: Bring Your Bottles to a Bottle Depot Location</p>
                <p className="py-3">Come in, drop your empties on the counters, and wait for one of our employees to count your total. No appointments needed.</p>
                <p className="text-2xl font-semibold">Step Three: Collect Your Cash</p>
                <p className="py-3">As soon as your empties are counted, you will be handed your deposit in cash!</p>

                <p className="text-2xl font-semibold py-2">Precounting</p>
                <p className="font-semibold">You can count your empties at home to save time at the store! Requirements for precounting include:</p>
                <p className="py-3">Empties must be in a clear plastic bag</p>
                <p className="py-3">Each bag must be labeled with the number of bottles inside</p>
                <p className="py-3">All empties in the bags must have a New York State deposit</p>
                <p className="py-3">Note: Bottle Depot reserves the right to verify the number of precounted bottles by taking a sample from the returned empties.</p>
            </div>

            <Footer />
        </div>
    )
}

export default ReturnProcess
